import {
	OPENING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE,
	CLOSING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE,
	REMOVING_CUSTOM_ATTRIBUTE_DEFINITION,
	RESET_CAD_LIST_DATA,
	SET_CAD_LIST_BEGIN_LOADING,
	SET_CAD_LIST_DATA,
	SET_CAD_LIST_STOP_LOADING,
} from './CADList.constants';

const INITIAL_STATE = {
	data: [],
	loading: false,
	deleteInProgress: false,
	showDeleteModal: false,
};

export default function (
	store = INITIAL_STATE,
	{ type, payload }: { type: string; payload?: any },
): any {
	switch (type) {
		case SET_CAD_LIST_DATA:
			return { ...store, data: payload.value };
		case RESET_CAD_LIST_DATA:
			return { ...store, data: [] };
		case SET_CAD_LIST_BEGIN_LOADING:
			return { ...store, loading: true };
		case SET_CAD_LIST_STOP_LOADING:
			return { ...store, loading: false };
		case OPENING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE: {
			return { ...store, showDeleteModal: true };
		}
		case CLOSING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE: {
			return { ...store, showDeleteModal: false, deleteInProgress: false };
		}
		case REMOVING_CUSTOM_ATTRIBUTE_DEFINITION: {
			return { ...store, deleteInProgress: true };
		}
		default:
			return store;
	}
}
